import axios from "axios";

const API_KEY = "66FJsdOt52LWZZsccvJqnvFpDK04dQPP";
const API_URL = `https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=10`;

export const fetchGifs = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data.data.map((gif) => ({
      id: gif.id,
      image: gif.images.fixed_height.url,
    }));
  } catch (error) {
    console.error("Error fetching images:", error);
    return [];
  }
};
